import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';
import { IconV2 } from 'components/common/IconV2/IconV2';

const ArrowLeftIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M12.547 22.542 6.01 16.005l6.537-6.536M6.052 16.005h20"
    />
  </IconV2>
);

export default ArrowLeftIcon;
